<template>
    <div class="documentation">
        <Breadcumb title="Ajouter un tag" :breadcumb-data="breadcumbData"></Breadcumb>
        <b-card class="cardcontainer">
            <b-form @submit="addTag">
                <b-form-group label="Label" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" placeholder="Label" v-model="label" :state="errors.label ? 'invalid': ''"/>
                    <div v-if="errors['label']" class="invalid-tooltip">{{ errors['label'][0] }}</div>
                </b-form-group>
                <b-form-group label="Tag Parent" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-select value="Choisir un tag parent" v-model="father" :options="fatherData"/>
                    <div v-if="errors['father']" class="invalid-tooltip">{{ errors['father'][0] }}</div>
                </b-form-group>
                <b-form-row>
                    <div class="col-md-10 ml-md-auto">
                        <b-btn type="submit" variant="primary">Ajouter le tag</b-btn>
                    </div>
                </b-form-row>
            </b-form>
        </b-card>
    </div>
</template>
<style src="@/vendor/libs/vue-color/vue-color.scss" lang="scss"></style>
<script>
    import { ADMIN_ADD_TAG_REQUEST } from '../../_store/administration/questionnary/actiontypes';
    import { mapState } from 'vuex';
    var vueColor = require('vue-color');
    import Breadcumb from '../../components/breadcumb';
    import {
        ADMIN_ADD_RESULTTAG_REQUEST,
        ADMIN_RESULTTAGS_REQUEST
    } from "../../_store/administration/result/actiontypes";

    export default {
        name: 'adminCategoryAdd',
        components: {
            Breadcumb
        },
        mounted() {
            this.$store.dispatch(ADMIN_RESULTTAGS_REQUEST, {full: 1})
                .then(response => {
                    this.fatherData = response.data.tags.map(tag => {
                        return {
                            value: tag.id,
                            text: tag.label
                        }
                    })
                })
        },
        computed: mapState({ errors: state => state.admin_document.errors }),
        data() {
            return ({
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Liste des tags de résultats', href: '/dashboard/administration/result/' },
                    { text: 'Ajouter un tag', active: true },
                ],
                fatherData: [],
                label: '',
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            addTag: function (e) {
                e.preventDefault();
                this.$store.dispatch(ADMIN_ADD_RESULTTAG_REQUEST, {
                    label: this.label,
                    father: this.father
                })
                    .then(() => {
                        this.$router.push('/dashboard/administration/results/');
                    })
                    .catch((error) => {
                        console.log('error is ==');
                        console.log(error);
                    });
            }
        }
    };
</script>
